import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { take } from "rxjs/operators";
import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import { PatientHistory } from "../../models/patient-chart/patient-history/patient-history";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class PatientHistoryServiceProvider {
  chartUrl: string;
  apiUrl: string;

  constructor(
    public http: HttpClient,
    private toastCtrl: ToastController,
    private config: ConfigurationService
  ) {
    this.chartUrl = this.config.resolvePatientChartsUrl();
  }

  getPatientHistoryData(
    patientId: number,
    page: number,
    size: number,
    direction: string,
    sortBy: string,
    historyEventType: string,
    toDate: string,
    externalId: boolean
  ): Observable<ContentWrapper<PatientHistory>> {
    return this.http
      .get<ContentWrapper<PatientHistory>>(
        `${this.chartUrl}/patients/${patientId}/history?page=${page}&limit=${size}&direction=${direction}&sortBy=${sortBy}&historyEventType=${historyEventType}&toDate=${toDate}&externalId=${externalId}`
      )
      .pipe(take(1));
  }

  createPatientHistoryRecord(
    patientId: number,
    externalId: boolean,
    requestObj: PatientHistory
  ) {
    return this.http
      .post(
        `${this.chartUrl}/patients/${patientId}/history?externalId=${externalId}`,
        requestObj
      )
      .pipe(take(1));
  }

  updatePatientHistoryRecord(
    patientId: number,
    externalId: boolean,
    patientHistoryId: number,
    requestObj: PatientHistory
  ) {
    return this.http
      .put(
        `${this.chartUrl}/patients/${patientId}/history/${patientHistoryId}?externalId=${externalId}`,
        requestObj
      )
      .pipe(take(1));
  }

  deletePatientHistoryRecord(
    patientId: number,
    externalId: boolean,
    patientHistoryId: number
  ) {
    return this.http.delete(
      `${this.chartUrl}/patients/${patientId}/history/${patientHistoryId}?externalId=${externalId}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/patient-history-service.ts